import { closeMenu, menuHeaderElement } from './menu';
import { debounce } from 'throttle-debounce';
import { BOOLEAN_STRING, MAGIC_NUMBERS, ARIA } from './constants';
import { focusElement, closer, matcher } from './lib';
import {
  a11yOpenkeyMatcher,
  keyPressIsEscape,
  keyPressIsArrowUp,
} from './keys';

const SEARCH_CONTAINER_ID = 'js-smaka-search-container';
const SEARCH_TOGGLE_BUTTON_ID = 'js-smaka-search-toggle-button';
const SEARCH_OPEN_CLASS = 'l-header--search-open';

const SEARCH_TOGGLE_CLOSER = closer(`#${SEARCH_TOGGLE_BUTTON_ID}`);
const SEARCH_TOGGLE_MATCHER = matcher(`#${SEARCH_TOGGLE_BUTTON_ID}`);

const searchButtonElement = () =>
  document.getElementById(SEARCH_TOGGLE_BUTTON_ID);

const searchContainerElement = () =>
  document.getElementById(SEARCH_CONTAINER_ID);

const searchContainerExpandedState = () =>
  searchButtonElement().getAttribute(ARIA.EXPANDED);

const openSearch = () => {
  searchButtonElement().setAttribute(ARIA.EXPANDED, BOOLEAN_STRING.TRUE);
  menuHeaderElement().classList.add(SEARCH_OPEN_CLASS);
  closeMenu();
  focusElement(searchContainerElement().querySelector('input'));
};

export const closeSearch = () => {
  searchButtonElement().setAttribute(ARIA.EXPANDED, BOOLEAN_STRING.FALSE);
  menuHeaderElement().classList.remove(SEARCH_OPEN_CLASS);
};

const toggleSearch = () => {
  searchContainerExpandedState() === BOOLEAN_STRING.TRUE
    ? closeSearch()
    : openSearch();
};

const searchClickHandler = event => {
  if (SEARCH_TOGGLE_CLOSER(event)) toggleSearch();
};

const headerKeyupHandler = debounce(MAGIC_NUMBERS.DEBOUNCE_INTERVAL, event => {
  if (keyPressIsEscape(event)) {
    closeSearch();
    focusElement(searchButtonElement());
  }

  if (a11yOpenkeyMatcher(event) && SEARCH_TOGGLE_MATCHER(event)) {
    openSearch();
  }

  if (keyPressIsArrowUp(event) && SEARCH_TOGGLE_MATCHER(event)) {
    openSearch();
  }
});

export function init() {
  searchButtonElement().addEventListener('click', searchClickHandler);
  searchContainerElement().addEventListener('click', searchClickHandler);
  document.addEventListener('keyup', headerKeyupHandler);
}
